<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
    left
    max-width="15vw"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="showBadge"
        :content="count"
        class="white--text"
        color="primary"
      >
        <v-btn v-bind="attrs" v-on="on" color="primary" small outlined>
          <v-icon dense x-small left>fa-filter</v-icon>
          Filtrar
        </v-btn>
      </v-badge>
    </template>
    <div class="d-flex flex-column px-6 py-4" :style="'gap: 16px; background-color: white'">
      <v-text-field
        v-for="item in inputs"
        :key="item.key"
        :value="faturamentoItensFilters[item.key]"
        :label="item.label"
        @input="event => debouncedFilterChange(item.key, event)"
        outlined
        clearable
        dense
        hide-details
      />
      <v-select
        :items="codigosDespesa"
        :value="codigoDespesa"
        label="Código despesa"
        @change="codigoDespesaChange"
        outlined
        clearable
        dense
        hide-details
      />
      <v-checkbox
        :value="faturamentoItensFilters['onlyPositiveValorGlosado']"
        @change="glosaCheckboxChange"
        class="mt-0"
        label="Ocultar itens sem glosa"
      />
      <v-checkbox
        :value="faturamentoItensFilters['onlyPositiveSaldo']"
        @change="saldoCheckboxChange"
        class="mt-0"
        label="Ocultar itens sem saldo e conciliados neste pagamento"
      />
    </div>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import { codigoDespesaLabels, codigoDespesaValues } from '@tradimus/api-conciliacao-client'

export default {
  data () {
    return {
      inputs: [
        { key: 'codigoProcedimento', label: 'Código procedimento' },
        { key: 'codigoTabela', label: 'Código tabela' },
        { key: 'descricaoProcedimento', label: 'Descrição procedimento' },
        { key: 'quantidade', label: 'Quantidade' },
        { key: 'valor', label: 'Valor' },
        { key: 'valorUnitario', label: 'Valor unitário' }
      ],
      codigosDespesa: [
        { text: 'Não informado', value: 'naoInformado' },
        ...codigoDespesaValues.map(codigo => ({ text: codigoDespesaLabels[codigo], value: codigo }))
      ],
      codigoDespesa: ''
    }
  },
  computed: {
    ...mapState('conciliacao', ['faturamentoItensFilters', 'pagamentoGuiaId']),
    count () {
      const filters = Object.keys(this.faturamentoItensFilters)
        .filter((key) => key.includes('pagamentoGuiaIds'))
        .reduce((current, key) => { return Object.assign(current, {[key]: this.faturamentoItensFilters[key]}) }, {})

      return Object.values(filters)
        .filter(value => Boolean(value))
        .length
    },
    showBadge () {
      return this.count > 0
    }
  },
  methods: {
    debouncedFilterChange (key, value) {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.$store.dispatch('conciliacao/partialUpdateFaturamentoItensFilters', { [key]: value })
      }, 500)
    },
    codigoDespesaChange (value) {
      let payload = {}

      if (value === 'naoInformado') {
        payload = {
          codigoDespesa: undefined,
          onlyNullCodigoDespesa: true
        }
      } else {
        payload = {
          codigoDespesa: value || undefined,
          onlyNullCodigoDespesa: undefined
        }
      }

      this.$store.dispatch('conciliacao/partialUpdateFaturamentoItensFilters', payload)
      this.codigoDespesa = value
    },
    glosaCheckboxChange (value) {
      const payload = {
        onlyPositiveValorGlosado: value ? value : undefined
      }
      this.$store.dispatch('conciliacao/partialUpdateFaturamentoItensFilters', payload)
    },
    saldoCheckboxChange (value) {
      const payload = {
        onlyPositiveSaldo: value || undefined,
      }
      this.$store.dispatch('conciliacao/partialUpdateFaturamentoItensFilters', payload)
    }
  },
  beforeDestroy () {
    clearTimeout(this._timerId)
  }
}
</script>
